module.exports = __webpack_public_path__ + "static/media/emoji-sad.e2bef87f.svg";